import React from 'react';
import autoBind from 'react-autobind';
import { Select, Tooltip as TooltipAntd } from 'antd';
import { Row, Col, FormGroup, OverlayTrigger, Tooltip } from 'react-bootstrap';
import _ from 'lodash';

class TypeaheadComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedValue: undefined,
      isOpen: false,
      inputValue: '',
    };

    autoBind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      (JSON.stringify(nextProps.value) != JSON.stringify(this.props.value) || !this.state.selectedValue) &&
      !this.timeout
    ) {
      const newValue = _.isString(nextProps.value)
        ? nextProps.value === ''
          ? undefined
          : nextProps.value
        : nextProps.value[nextProps.labelKey || 'Exibicao'];
      if (newValue != this.state.selectedValue) {
        this.setState({
          selectedValue: newValue,
          isOpen: false,
        });
      }
    }
  }

  onChange(value) {
    const { itens, labelKey } = this.props;

    this.setState({
      selectedValue: value,
      isOpen: false,
    });

    let data = itens.find((x) => x[labelKey || 'Exibicao'] === value);

    this.props.onChange && this.props.onChange(data);
  }

  onFocus() {
    this.setState({ isOpen: true });
  }

  onClear() {
    this.setState({ selectedValue: '' });

    this.props.onChange && this.props.onChange('');
  }

  onBlur() {
    this.setState({
      isOpen: false,
    });
  }

  handleChangeInput = (value) => {
    this.setState({ inputValue: value });
  };

  async onAddRegistro() {
    if (!this.state.inputValue.trim()) {
      await _alert.warning('Por favor, insira um valor antes de adicionar um registro.');
    } else {
      this.props.addItem(this.state.inputValue);

      this.setState({
        isOpen: false,
        selectedValue: this.state.inputValue,
      });
    }
  }

  render() {
    const { placeholder, disabled, className, title, itens, name, labelKey, valueKey, addItem } = this.props;
    const { selectedValue, isOpen } = this.state;

    return (
      <Row>
        <Col>
          <OverlayTrigger key={'top'} placement={'top'} overlay={<Tooltip id={`tooltip-top`}>{title}</Tooltip>}>
            <FormGroup
              onClick={() => {
                if (!isOpen) {
                  this.setState({
                    isOpen: true,
                  });
                }
              }}
            >
              <Select
                showSearch
                allowClear={true}
                value={selectedValue}
                name={name}
                placeholder={placeholder}
                className={className}
                disabled={disabled}
                open={isOpen}
                onClear={this.onClear}
                onFocus={this.onFocus}
                onChange={this.onChange}
                onBlur={this.onBlur}
                style={{ width: '100%' }}
                optionFilterProp="label"
                onSearch={this.handleChangeInput}
                filterOption={(input, option) => option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                notFoundContent={
                  <div style={{ textAlign: 'center' }}>
                    <p style={{ color: 'black' }}>Nenhum registro encontrado...</p>
                    {addItem && (
                      <button
                        type="button"
                        className="btn btn-primary btn-custom mr-2"
                        onClick={() => this.onAddRegistro()}
                      >
                        <TooltipAntd
                          zIndex={10000000}
                          placement="right"
                          title={'Adicionar o Registro Descrito no Campo'}
                        >
                          Adicionar Registro
                        </TooltipAntd>
                      </button>
                    )}
                  </div>
                }
              >
                {itens?.map((item) => (
                  <Select.Option
                    key={item['Id' || valueKey || labelKey || 'Exibicao']}
                    value={item[valueKey || labelKey || 'Exibicao']}
                  >
                    <TooltipAntd zIndex={10000000} placement="right" title={item[labelKey || 'Exibicao']}>
                      {item[labelKey || 'Exibicao']}
                    </TooltipAntd>
                  </Select.Option>
                ))}
              </Select>
            </FormGroup>
          </OverlayTrigger>
        </Col>
      </Row>
    );
  }
}

export default TypeaheadComponent;
